import {removeAccessAdministrationUserRole} from "@project/sdk/access-administration";
import {RemoveAccessAdministrationUserRoleResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {accessAdministrationMutationKeys, userAccessKeys} from "../../access-administration-keys";

export function removeUserRoleMutationOptions(userId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.removeUserRole,
    mutationFn: async (roleId: string) =>
      RemoveAccessAdministrationUserRoleResponse.parse(
        await removeAccessAdministrationUserRole(userId, roleId),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userAccessKeys.detail(userId)});
    },
  });
}
